class Aggression {
    constructor(age, name, cost, text, effect)
    {
        this.age = age;
        this.name = name;
        this.cost = cost;
        this.text = text;
        this.effect = effect;
    }

    GetAge() {
        return this.age;
    }

    GetName() {
        return this.name;
    }

    GetText() {
        return this.text;
    }

    GetEffects = () => this.effect;
}

module.exports = Aggression;